import * as types from '../../actionTypes';

const initialState = {
    updateAppointments: [],
    error: {},
    loading: false,
}



export  const updateAppointmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_APPOINTMENT_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.UPDATE_APPOINTMENT_SUCCESS:
            console.log("actionddddd",action.payload)
            return {
                ...state,
                updateAppointments: action.payload,
                loading: false,
                error: {}
            }
        case types.UPDATE_APPOINTMENT_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
                updateAppointments: []
            }
        
        default:
            return state;
    }
}